import { Svg } from 'components/svg'

export const IconSoundOn = () => (
  <Svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g id="Group_2" data-name="Group 2" transform="translate(-0.848 0.07)">
      <path
        d="M11.848,4a1,1,0,0,1,1,1V19a1,1,0,0,1-1.625.781L6.5,16H2.848a1,1,0,0,1-1-1V9a1,1,0,0,1,1-1H6.5l4.726-3.781A1,1,0,0,1,11.848,4Zm-1,12.919V7.081l-3.375,2.7A1,1,0,0,1,6.848,10h-3v4h3a1,1,0,0,1,.625.219Z"
        fill="currentColor"
      />
      <path
        d="M16.388,16.53a1,1,0,0,1-.707-1.707,4,4,0,0,0,0-5.656A1,1,0,0,1,17.1,7.753a6,6,0,0,1,0,8.484A1,1,0,0,1,16.388,16.53Z"
        fill="currentColor"
      />
      <path
        d="M19.918,20.07a1,1,0,0,1-.707-1.707,9,9,0,0,0,0-12.726,1,1,0,1,1,1.414-1.414,11,11,0,0,1,0,15.554A1,1,0,0,1,19.918,20.07Z"
        fill="currentColor"
      />
    </g>
  </Svg>
)
